<div>
    <div class="flex">
        <div class="mr-6 mt-2" *ngIf="isTrialActive()">
            <span>{{ "topbar_trial1" | translate }} </span>{{ trialDaysLeft }}<span> {{ "topbar_trial2" | translate }}</span>
        </div>

        @if (isTrialActive()) {
            <p-button pRipple label="{{ 'topbar_trial_button_buy' | translate }}" (click)="linkToStore()" severity="success" />
        }

        @if (displayTrialButtonStart() && displayStartTrialButton) {
            <p-button
                pRipple
                label="{{ 'topbar_trial_button_start' | translate }}"
                (click)="displayModalStartTrial = true"
                severity="success"
                outlined
            ></p-button>
        }

        @if (isTrialExpired()) {
            <p-button pRipple label="{{ 'topbar_trial_button_buy' | translate }}" (click)="linkToStore()" severity="success" outlined />
        }
    </div>

    <app-dialog-trial-started
        [showDialog]="displayModalTrialStarted"
        (onHide)="load()"
        (openModalTryHardwareClicked)="openModalTryHardware()"
    ></app-dialog-trial-started>

    <app-dialog-trial-ended
        [showDialog]="displayModalTrialEnded"
        (trialEndedDowngrade)="trialEndedDowngrade()"
        (trialEndedSales)="trialEndedSales()"
        (trialEndedUpgrade)="trialEndedUpgrade()"
    ></app-dialog-trial-ended>

    <p-dialog
        class="my-dialog"
        [(visible)]="displayModalStartTrial"
        [draggable]="false"
        [style]="{ maxHeight: '100%', width: '70vw' }"
        [breakpoints]="{
            '1200px': '80vw',
            '800px': '100vw',
        }"
        [closable]="false"
        [closeOnEscape]="false"
        [modal]="true"
        [showHeader]="false"
    >
        <ng-template pTemplate="content">
            <div class="grid grid-cols-12 gap-4 sm:mt-1 md:mt-8 lg:mt-8">
                <div
                    class="col-span-12 md:col-span-6 lg:col-span-6 mt-4 md:mt-1 lg-mt-1 flex flex-wrap content-center justify-center"
                    style="background-color: #eff0f5; border-radius: 5%"
                >
                    <div class="flex flex-wrap content-center justify-center" *ngIf="dialogPage === 0">
                        <img src="{{ 'dialog_starttrial_background_buzzer' | translate }}" width="80%" max-height="100%" alt="" />
                    </div>
                    <div class="flex flex-wrap content-center justify-center" *ngIf="dialogPage !== 0">
                        <img src="{{ 'dialog_starttrial_background_trial' | translate }}" width="90%" max-height="100%" alt="" />
                    </div>
                </div>
                @if (dialogPage === 0) {
                    <div class="col-span-12 md:col-span-6 lg:col-span-6">
                        <div class="justify-start lg:ml-20">
                            <div class="col-span-12 mb-16 mt-8">
                                <p-steps [model]="stepItems" [activeIndex]="activeIndex"></p-steps>
                            </div>
                            <div class="col-span-12 mb-8 lg:mb-16">
                                <p class="text-4xl mb-6">{{ "dialog_starttrial_step_buzzer_header" | translate }}</p>
                                <p class="text-xl">{{ "dialog_starttrial_step_buzzer_subheader" | translate }}</p>
                            </div>
                            <div class="col-span-12 text-lg mb-4 md:mb-16 lg:mb-16">
                                <ul class="feature-list">
                                    <li class="mb-2">
                                        <i class="feature-icon pi pi-check-circle"></i>
                                        {{ "dialog_starttrial_step_buzzer_list_1" | translate }}
                                    </li>
                                    <li class="mb-2">
                                        <i class="feature-icon pi pi-check-circle"></i>
                                        {{ "dialog_starttrial_step_buzzer_list_2" | translate }}
                                    </li>
                                </ul>
                            </div>
                            <div class="col-span-12 md:mb-16 lg:mb-16">&nbsp;</div>
                        </div>
                        <div class="flex flex-wrap justify-center lg:justify-end">
                            <p-button
                                pRipple
                                type="button"
                                styleClass="p-button-text ml-4 mr-12 mb-4"
                                label="{{ 'dialog_starttrial_button_skip' | translate }}"
                                (click)="skipStep()"
                            >
                            </p-button>
                            <p-button
                                pRipple
                                type="button"
                                styleClass="p-button mr-6"
                                label="{{ 'dialog_starttrial_step_buzzer_button_start' | translate }}"
                                (click)="nextStep()"
                            ></p-button>
                        </div>
                    </div>
                } @else if (dialogPage === 1) {
                    <!-- Order hardware, 30 days trial -->
                    <div class="col-span-12 md:col-span-6 lg:col-span-6">
                        <div class="justify-start lg:ml-20">
                            <div class="col-span-12 mb-8 mt-8">
                                <p-steps [model]="stepItems" [activeIndex]="activeIndex"></p-steps>
                            </div>
                            <div class="col-span-12 mb-8 lg:mb-16">
                                <p class="text-4xl mb-6">{{ "dialog_starttrial_step_trial_30_header" | translate }}</p>
                                <p class="text-xl">{{ "dialog_starttrial_step_trial_30_subheader" | translate }}</p>
                            </div>
                            <div class="col-span-12 text-lg mb-16">
                                <ul class="feature-list">
                                    <li class="mb-2">
                                        <i class="feature-icon pi pi-check-circle"></i>{{ "dialog_starttrial_step_trial_30_list_1" | translate }}
                                    </li>
                                    <li class="mb-2">
                                        <i class="feature-icon pi pi-check-circle"></i>{{ "dialog_starttrial_step_trial_30_list_2" | translate }}
                                    </li>
                                </ul>
                            </div>
                            <div class="col-span-12 mb-6 lg:mb-12">
                                <p class="text-surface-700 dark:text-surface-100">{{ "dialog_starttrial_step_trial_30_tip" | translate }}</p>
                            </div>
                        </div>
                        <div class="flex flex-wrap justify-center">
                            <p-button
                                pRipple
                                type="button"
                                styleClass="flex items-stretch justify-center"
                                label="{{ 'dialog_starttrial_step_trial_30_button_start' | translate }}"
                                (click)="startTrial(30)"
                            ></p-button>
                        </div>
                    </div>
                } @else if (dialogPage === 2) {
                    <!-- Order hardware, 15 days trial -->
                    <div class="col-span-12 md:col-span-6 lg:col-span-6" *ngIf="dialogPage === 2">
                        <div class="justify-start lg:ml-20">
                            <div class="col-span-12 mb-8 mt-8">
                                <p-steps [model]="stepItems" [activeIndex]="activeIndex"></p-steps>
                            </div>
                            <div class="col-span-12 mb-8 lg:mb-16">
                                <p class="text-4xl mb-6">{{ "dialog_starttrial_step_trial_15_header" | translate }}</p>
                                <p class="text-xl">{{ "dialog_starttrial_step_trial_15_subheader" | translate }}</p>
                            </div>
                            <div class="col-span-12 text-lg md:mb-6 lg:mb-6">
                                <ul class="feature-list">
                                    <li class="mb-2">
                                        <i class="feature-icon pi pi-check-circle"></i>{{ "dialog_starttrial_step_trial_15_list_1" | translate }}
                                    </li>
                                    <li class="mb-2">
                                        <i class="feature-icon pi pi-check-circle"></i>{{ "dialog_starttrial_step_trial_15_list_2" | translate }}
                                    </li>
                                </ul>
                            </div>
                            <div class="col-span-12 mb-1 md:mb-6 lg:mb-6">
                                <p class="text-surface-700 dark:text-surface-100">{{ "dialog_starttrial_step_trial_15_tip" | translate }}</p>
                            </div>
                        </div>
                        <div class="flex flex-wrap justify-center lg:justify-end pt-4">
                            <p-button
                                pRipple
                                type="button"
                                styleClass="p-button-text ml-4 mr-12 mb-4"
                                label="{{ 'dialog_starttrial_button_go_back' | translate }}"
                                (click)="previousStep()"
                            >
                            </p-button>
                            <p-button
                                pRipple
                                type="button"
                                styleClass="p-button mr-6"
                                label="{{ 'dialog_starttrial_step_trial_15_button_start' | translate }}"
                                (click)="startTrial(15)"
                            ></p-button>
                        </div>
                    </div>
                }
            </div>
        </ng-template>
    </p-dialog>
</div>
